(function () {
	'use strict';

	angular
		.module('app.setup')
		.controller('shortageCriticalityCustomerConfig', shortageCriticalityCustomerConfig);

	shortageCriticalityCustomerConfig.$inject = ['$rootScope', '$scope', '$timeout', 'storeService'];

	function shortageCriticalityCustomerConfig($rootScope, $scope, $timeout, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;

		vm.showAddExclusionRule = true;
		vm.showAddCriticalityLevel = true;

		$scope.type = 'customer';
		$scope.siteId = adminConfig.factory.id;
		$scope.customerId = adminConfig.customer.id;
	}
})();